import { SelectItem } from 'src/components/Reusable/SelectDropdown/SelectDropdown.constants'

// Default timezone for schedules without a stored timezone (legacy schedules)
export const DEFAULT_SCHEDULE_TIMEZONE = 'GMT'

export enum ScheduleFrequency {
  HOURLY = 0,
  DAY = 1,
  WEEK = 2,
  MONTH = 3,
  QUARTERLY = 4,
  THIRTYMINUTES = 5,
  ANNUALLY = 6,
}

export enum WeekDay {
  SUNDAY = 0,
  MONDAY = 1,
  TUESDAY = 2,
  WEDNESDAY = 3,
  THURSDAY = 4,
  FRIDAY = 5,
  SATURDAY = 6,
}

export const WEEK_DAY_MAP: Record<WeekDay, string> = {
  [WeekDay.SUNDAY]: 'SUN',
  [WeekDay.MONDAY]: 'MON',
  [WeekDay.TUESDAY]: 'TUE',
  [WeekDay.WEDNESDAY]: 'WED',
  [WeekDay.THURSDAY]: 'THU',
  [WeekDay.FRIDAY]: 'FRI',
  [WeekDay.SATURDAY]: 'SAT',
}

export enum ScheduleEvent {
  EVIDENCE_COLLECTION = 0,
  EXAMINATION_AND_TEST = 1,
  PLAYBOOK = 2,
}

export const FREQUENCY_OPTIONS: SelectItem[] = [
  { name: '30 Minutes', value: ScheduleFrequency.THIRTYMINUTES },
  { name: 'Hourly', value: ScheduleFrequency.HOURLY },
  { name: 'Daily', value: ScheduleFrequency.DAY },
  { name: 'Weekly', value: ScheduleFrequency.WEEK },
  { name: 'Monthly', value: ScheduleFrequency.MONTH },
  { name: 'Quarterly', value: ScheduleFrequency.QUARTERLY },
  { name: 'Annually', value: ScheduleFrequency.ANNUALLY },
]

export const HOURLY_OPTIONS: SelectItem[] = [
  { name: 'Every hour', value: 1 },
  { name: 'Every 2 hours', value: 2 },
  { name: 'Every 3 hours', value: 3 },
  { name: 'Every 4 hours', value: 4 },
  { name: 'Every 6 hours', value: 6 },
  { name: 'Every 8 hours', value: 8 },
  { name: 'Every 12 hours', value: 12 },
]

export const DAILY_OPTIONS: SelectItem[] = [
  { name: 'Every day', value: 1 },
  { name: 'Every 2 days', value: 2 },
  { name: 'Every 3 days', value: 3 },
  { name: 'Every 4 days', value: 4 },
  { name: 'Every 5 days', value: 5 },
  { name: 'Every 6 days', value: 6 },
]

export const WEEKLY_OPTIONS: SelectItem[] = [
  { name: 'Every week', value: 1 },
  { name: 'Every 2 weeks', value: 2 },
  { name: 'Every 3 weeks', value: 3 },
  { name: 'Every 4 weeks', value: 4 },
  { name: 'Every 5 weeks', value: 5 },
  { name: 'Every 6 weeks', value: 6 },
]

export const MONTHLY_OPTIONS: SelectItem[] = [
  { name: 'Every month', value: 1 },
  { name: 'Every 2 months', value: 2 },
  { name: 'Every 3 months', value: 3 },
]

export const DAYS_OF_WEEK_OPTIONS: SelectItem[] = [
  { name: 'Monday', value: WeekDay.MONDAY },
  { name: 'Tuesday', value: WeekDay.TUESDAY },
  { name: 'Wednesday', value: WeekDay.WEDNESDAY },
  { name: 'Thursday', value: WeekDay.THURSDAY },
  { name: 'Friday', value: WeekDay.FRIDAY },
  { name: 'Saturday', value: WeekDay.SATURDAY },
  { name: 'Sunday', value: WeekDay.SUNDAY },
]

export const MONTH_QUARTER_OPTIONS: SelectItem[] = [
  { name: '1st', value: 1 },
  { name: '2nd', value: 2 },
  { name: '3rd', value: 3 },
]

export const MONTH_QUARTERS_MAP: Record<number, string> = {
  1: '1,4,7,10',
  2: '2,5,8,11',
  3: '3,6,9,12',
}

export const ORDINAL_DAY_OPTIONS: SelectItem[] = [
  { name: '1st', value: 1 },
  { name: '2nd', value: 2 },
  { name: '3rd', value: 3 },
  { name: '4th', value: 4 },
  { name: '5th', value: 5 },
  { name: '6th', value: 6 },
  { name: '7th', value: 7 },
  { name: '8th', value: 8 },
  { name: '9th', value: 9 },
  { name: '10th', value: 10 },
  { name: '11th', value: 11 },
  { name: '12th', value: 12 },
  { name: '13th', value: 13 },
  { name: '14th', value: 14 },
  { name: '15th', value: 15 },
  { name: '16th', value: 16 },
  { name: '17th', value: 17 },
  { name: '18th', value: 18 },
  { name: '19th', value: 19 },
  { name: '20th', value: 20 },
  { name: '21st', value: 21 },
  { name: '22nd', value: 22 },
  { name: '23rd', value: 23 },
  { name: '24th', value: 24 },
  { name: '25th', value: 25 },
  { name: '26th', value: 26 },
  { name: '27th', value: 27 },
  { name: '28th', value: 28 },
  { name: '29th', value: 29 },
  { name: '30th', value: 30 },
  { name: '31st', value: 31 },
]

export const TIME_OPTIONS: SelectItem[] = [
  { name: '12:00 AM', value: '00:00 AM' },
  { name: '12:30 AM', value: '00:30 AM' },
  { name: '01:00 AM', value: '01:00 AM' },
  { name: '01:30 AM', value: '01:30 AM' },
  { name: '02:00 AM', value: '02:00 AM' },
  { name: '02:30 AM', value: '02:30 AM' },
  { name: '03:00 AM', value: '03:00 AM' },
  { name: '03:30 AM', value: '03:30 AM' },
  { name: '04:00 AM', value: '04:00 AM' },
  { name: '04:30 AM', value: '04:30 AM' },
  { name: '05:00 AM', value: '05:00 AM' },
  { name: '05:30 AM', value: '05:30 AM' },
  { name: '06:00 AM', value: '06:00 AM' },
  { name: '06:30 AM', value: '06:30 AM' },
  { name: '07:00 AM', value: '07:00 AM' },
  { name: '07:30 AM', value: '07:30 AM' },
  { name: '08:00 AM', value: '08:00 AM' },
  { name: '08:30 AM', value: '08:30 AM' },
  { name: '09:00 AM', value: '09:00 AM' },
  { name: '09:30 AM', value: '09:30 AM' },
  { name: '10:00 AM', value: '10:00 AM' },
  { name: '10:30 AM', value: '10:30 AM' },
  { name: '11:00 AM', value: '11:00 AM' },
  { name: '11:30 AM', value: '11:30 AM' },
  { name: '12:00 PM', value: '12:00 PM' },
  { name: '12:30 PM', value: '12:30 PM' },
  { name: '01:00 PM', value: '01:00 PM' },
  { name: '01:30 PM', value: '01:30 PM' },
  { name: '02:00 PM', value: '02:00 PM' },
  { name: '02:30 PM', value: '02:30 PM' },
  { name: '03:00 PM', value: '03:00 PM' },
  { name: '03:30 PM', value: '03:30 PM' },
  { name: '04:00 PM', value: '04:00 PM' },
  { name: '04:30 PM', value: '04:30 PM' },
  { name: '05:00 PM', value: '05:00 PM' },
  { name: '05:30 PM', value: '05:30 PM' },
  { name: '06:00 PM', value: '06:00 PM' },
  { name: '06:30 PM', value: '06:30 PM' },
  { name: '07:00 PM', value: '07:00 PM' },
  { name: '07:30 PM', value: '07:30 PM' },
  { name: '08:00 PM', value: '08:00 PM' },
  { name: '08:30 PM', value: '08:30 PM' },
  { name: '09:00 PM', value: '09:00 PM' },
  { name: '09:30 PM', value: '09:30 PM' },
  { name: '10:00 PM', value: '10:00 PM' },
  { name: '10:30 PM', value: '10:30 PM' },
  { name: '11:00 PM', value: '11:00 PM' },
  { name: '11:30 PM', value: '11:30 PM' },
]

export const MONTH_NAME_OPTIONS: SelectItem[] = [
  { name: 'January', value: 1 },
  { name: 'February', value: 2 },
  { name: 'March', value: 3 },
  { name: 'April', value: 4 },
  { name: 'May', value: 5 },
  { name: 'June', value: 6 },
  { name: 'July', value: 7 },
  { name: 'August', value: 8 },
  { name: 'September', value: 9 },
  { name: 'October', value: 10 },
  { name: 'November', value: 11 },
  { name: 'December', value: 12 },
]

export enum CardType {
  EVIDENCE_BY_TYPE = 'Evidence collection by type',
  EVIDENCE_BY_RECEPTOR = 'Evidence collection by receptor',
  EXAM_ALL_CONTROLS = 'Examine and test all controls',
  EXAM_BY_FRAMEWORK = 'Examine and test by framework',
  EXAM_BY_CONTROL = 'Examine and test by control',
  PLAYBOOK = 'Playbook',
}
